import { CaixaArredondada } from '../../componentes/CaixaArredondada'
import {
  Giroflex,
  RetrovisorViatura,
  RodaViatura,
  texturaDeChevron,
  texturaDeLetreiro,
  texturaDePersiana,
} from './pecasViatura'

/**
 * Auto Bomba Tanque e Salvamento (ABT), em escala real: ~7,2 m × 2,4 m.
 *
 * A frente fica em −X, como nas outras viaturas da mesa. Cabine dupla com
 * janelas por porta, grade e faróis com moldura; baú com portas de enrolar em
 * lâminas; escada, canhão e carretel no teto; chevron e degrau na traseira.
 */

const VERMELHO = '#dc2626'
const VERMELHO_ESCURO = '#a51d1d'
const PRETO = '#15181c'
const ALUMINIO = '#cbd5e1'
const CROMO = '#d9dee4'
const VIDRO = '#5a7890'

const semRaycast = () => null

/** Altura do piso da cabine e do baú sobre o chão. */
const Y_CHASSI = 0.98
const X_FRENTE = -3.55
const X_CABINE_TRAS = -1.3
const X_TRASEIRA = 3.5
const MEIA_LARGURA = 1.2
const Y_TETO_CABINE = 2.95
const Y_TETO_BAU = 3.05

export function CaminhaoBombeiros3D() {
  const comprimentoCabine = X_CABINE_TRAS - X_FRENTE
  const xCabine = (X_FRENTE + X_CABINE_TRAS) / 2
  const xBauFrente = X_CABINE_TRAS + 0.12
  const comprimentoBau = X_TRASEIRA - xBauFrente
  const xBau = (xBauFrente + X_TRASEIRA) / 2
  const persiana = texturaDePersiana()
  const chevron = texturaDeChevron()
  const letreiro = texturaDeLetreiro('BOMBEIROS', '193')

  return (
    <group name="caminhao-bombeiros">
      {/* --- chassi, tanque de combustível e para-lamas --- */}
      <mesh raycast={semRaycast} castShadow position={[0, 0.78, 0]}>
        <boxGeometry args={[X_TRASEIRA - X_FRENTE - 0.3, 0.22, 1.0]} />
        <meshStandardMaterial color={PRETO} roughness={0.7} />
      </mesh>
      {[-1, 1].map((lado) => (
        <group key={lado}>
          <mesh raycast={semRaycast} castShadow position={[-0.55, 0.75, lado * 0.82]} rotation={[Math.PI / 2, 0, 0]}>
            <cylinderGeometry args={[0.24, 0.24, 0.36, 18]} />
            <meshStandardMaterial color="#9aa3ad" metalness={0.7} roughness={0.35} />
          </mesh>
          {/* para-lamas: arco preto sobre cada roda */}
          {[-2.35, 2.05].map((x) => (
            <mesh key={x} raycast={semRaycast} castShadow position={[x, 1.08, lado * (MEIA_LARGURA - 0.02)]}>
              <CaixaArredondada args={[x > 0 ? 1.55 : 1.25, 0.1, 0.42]} raio={0.04} />
              <meshStandardMaterial color={PRETO} roughness={0.75} />
            </mesh>
          ))}
        </group>
      ))}

      {/* --- cabine dupla --- */}
      <group>
        <mesh raycast={semRaycast} castShadow receiveShadow position={[xCabine, (Y_CHASSI + Y_TETO_CABINE) / 2, 0]}>
          <CaixaArredondada args={[comprimentoCabine, Y_TETO_CABINE - Y_CHASSI, MEIA_LARGURA * 2]} raio={0.12} />
          <meshStandardMaterial color={VERMELHO} roughness={0.32} metalness={0.15} />
        </mesh>
        {/* teto branco de comando */}
        <mesh raycast={semRaycast} position={[xCabine, Y_TETO_CABINE + 0.005, 0]}>
          <CaixaArredondada args={[comprimentoCabine - 0.06, 0.04, MEIA_LARGURA * 2 - 0.06]} raio={0.02} />
          <meshStandardMaterial color="#f4f6f8" roughness={0.45} />
        </mesh>
        {/* para-brisa inclinado e colunas */}
        <mesh raycast={semRaycast} position={[X_FRENTE - 0.005, 2.38, 0]} rotation={[0, 0, -0.1]}>
          <boxGeometry args={[0.02, 0.86, MEIA_LARGURA * 2 - 0.22]} />
          <meshStandardMaterial color={VIDRO} metalness={0.3} roughness={0.1} envMapIntensity={1.4} />
        </mesh>
        {/* grade com barras cromadas */}
        <mesh raycast={semRaycast} position={[X_FRENTE - 0.01, 1.45, 0]}>
          <boxGeometry args={[0.02, 0.62, 1.5]} />
          <meshStandardMaterial color="#1b1f24" roughness={0.6} />
        </mesh>
        {[0, 1, 2, 3, 4].map((i) => (
          <mesh key={i} raycast={semRaycast} position={[X_FRENTE - 0.025, 1.22 + i * 0.115, 0]}>
            <boxGeometry args={[0.02, 0.035, 1.46]} />
            <meshStandardMaterial color={CROMO} metalness={0.85} roughness={0.2} />
          </mesh>
        ))}
        {/* faróis com moldura e pisca âmbar */}
        {[-1, 1].map((lado) => (
          <group key={lado} position={[X_FRENTE - 0.02, 1.45, lado * 0.98]}>
            <mesh raycast={semRaycast}>
              <boxGeometry args={[0.04, 0.3, 0.36]} />
              <meshStandardMaterial color={CROMO} metalness={0.8} roughness={0.25} />
            </mesh>
            <mesh raycast={semRaycast} position={[-0.022, 0.03, 0]}>
              <boxGeometry args={[0.01, 0.2, 0.28]} />
              <meshStandardMaterial color="#fffbe8" emissive="#fff6d6" emissiveIntensity={0.9} />
            </mesh>
            <mesh raycast={semRaycast} position={[-0.022, -0.12, 0]}>
              <boxGeometry args={[0.01, 0.05, 0.28]} />
              <meshStandardMaterial color="#f59e0b" emissive="#f59e0b" emissiveIntensity={0.5} />
            </mesh>
          </group>
        ))}
        {/* para-choque de aço com ganchos de reboque */}
        <mesh raycast={semRaycast} castShadow position={[X_FRENTE - 0.1, 0.92, 0]}>
          <CaixaArredondada args={[0.26, 0.34, MEIA_LARGURA * 2 + 0.06]} raio={0.04} />
          <meshStandardMaterial color="#2a2f35" metalness={0.55} roughness={0.45} />
        </mesh>
        {[-0.6, 0.6].map((z) => (
          <mesh key={z} raycast={semRaycast} position={[X_FRENTE - 0.25, 0.86, z]} rotation={[0, 0, Math.PI / 2]}>
            <torusGeometry args={[0.06, 0.018, 6, 12]} />
            <meshStandardMaterial color={VERMELHO} roughness={0.4} />
          </mesh>
        ))}

        {[-1, 1].map((lado) => {
          const zFace = lado * (MEIA_LARGURA + 0.004)
          return (
            <group key={lado}>
              {/* janelas da porta dianteira e da porta da guarnição */}
              {[X_FRENTE + 0.55, X_FRENTE + 1.55].map((x) => (
                <mesh key={x} raycast={semRaycast} position={[x, 2.35, zFace]}>
                  <boxGeometry args={[0.82, 0.72, 0.012]} />
                  <meshStandardMaterial color={VIDRO} metalness={0.3} roughness={0.1} envMapIntensity={1.4} />
                </mesh>
              ))}
              {/* frisos das portas */}
              {[X_FRENTE + 0.1, X_FRENTE + 1.05, X_FRENTE + 2.05].map((x) => (
                <mesh key={x} raycast={semRaycast} position={[x, 1.95, zFace]}>
                  <boxGeometry args={[0.015, 1.85, 0.012]} />
                  <meshStandardMaterial color={VERMELHO_ESCURO} roughness={0.5} />
                </mesh>
              ))}
              {/* maçanetas */}
              {[X_FRENTE + 0.9, X_FRENTE + 1.9].map((x) => (
                <mesh key={x} raycast={semRaycast} position={[x, 1.85, zFace + lado * 0.012]}>
                  <boxGeometry args={[0.16, 0.035, 0.02]} />
                  <meshStandardMaterial color={CROMO} metalness={0.85} roughness={0.2} />
                </mesh>
              ))}
              {/* letreiro BOMBEIROS 193 na porta */}
              {letreiro && (
                <mesh raycast={semRaycast} position={[X_FRENTE + 0.55, 1.5, zFace + lado * 0.004]} rotation={[0, lado > 0 ? 0 : Math.PI, 0]}>
                  <planeGeometry args={[0.8, 0.4]} />
                  <meshStandardMaterial map={letreiro} transparent roughness={0.4} />
                </mesh>
              )}
              {/* degraus de acesso */}
              {[X_FRENTE + 0.55, X_FRENTE + 1.55].map((x) => (
                <mesh key={x} raycast={semRaycast} castShadow position={[x, 0.72, lado * (MEIA_LARGURA - 0.05)]}>
                  <boxGeometry args={[0.6, 0.04, 0.24]} />
                  <meshStandardMaterial color="#9aa3ad" metalness={0.7} roughness={0.4} />
                </mesh>
              ))}
              <RetrovisorViatura posicao={[X_FRENTE + 0.25, 2.3, lado * MEIA_LARGURA]} lado={lado as 1 | -1} />
            </group>
          )
        })}
        <Giroflex posicao={[X_FRENTE + 0.45, Y_TETO_CABINE + 0.06, 0]} comprimento={1.9} />
      </group>

      {/* --- baú de equipamentos --- */}
      <group>
        <mesh raycast={semRaycast} castShadow receiveShadow position={[xBau, (Y_CHASSI + Y_TETO_BAU) / 2, 0]}>
          <CaixaArredondada args={[comprimentoBau, Y_TETO_BAU - Y_CHASSI, MEIA_LARGURA * 2]} raio={0.08} />
          <meshStandardMaterial color={VERMELHO} roughness={0.32} metalness={0.15} />
        </mesh>
        {[-1, 1].map((lado) => {
          const zFace = lado * (MEIA_LARGURA + 0.006)
          const portas = 3
          const largura = (comprimentoBau - 0.4) / portas
          return (
            <group key={lado}>
              {Array.from({ length: portas }, (_, i) => {
                const x = xBauFrente + 0.2 + largura * (i + 0.5)
                return (
                  <group key={i}>
                    {/* porta de enrolar em lâminas de alumínio */}
                    <mesh raycast={semRaycast} position={[x, 2.15, zFace]}>
                      <boxGeometry args={[largura - 0.14, 1.35, 0.012]} />
                      <meshStandardMaterial
                        color={ALUMINIO}
                        map={persiana ?? undefined}
                        metalness={0.55}
                        roughness={0.38}
                      />
                    </mesh>
                    {/* barra de abertura */}
                    <mesh raycast={semRaycast} position={[x, 1.52, zFace + lado * 0.02]}>
                      <boxGeometry args={[largura - 0.3, 0.05, 0.03]} />
                      <meshStandardMaterial color={CROMO} metalness={0.85} roughness={0.2} />
                    </mesh>
                  </group>
                )
              })}
              {/* faixa refletiva ao longo de toda a viatura */}
              <mesh raycast={semRaycast} position={[(X_FRENTE + X_TRASEIRA) / 2, 1.3, lado * (MEIA_LARGURA + 0.01)]}>
                <boxGeometry args={[X_TRASEIRA - X_FRENTE - 0.2, 0.12, 0.006]} />
                <meshStandardMaterial color="#fde047" emissive="#fde047" emissiveIntensity={0.25} roughness={0.35} />
              </mesh>
              <mesh raycast={semRaycast} position={[(X_FRENTE + X_TRASEIRA) / 2, 1.2, lado * (MEIA_LARGURA + 0.01)]}>
                <boxGeometry args={[X_TRASEIRA - X_FRENTE - 0.2, 0.05, 0.006]} />
                <meshStandardMaterial color="#f8fafc" emissive="#ffffff" emissiveIntensity={0.15} roughness={0.35} />
              </mesh>
            </group>
          )
        })}

        {/* teto: escada com degraus, canhão monitor e carretel */}
        <group position={[xBau, Y_TETO_BAU, -0.55]}>
          {[-0.26, 0.26].map((z) => (
            <mesh key={z} raycast={semRaycast} castShadow position={[0, 0.16, z]}>
              <boxGeometry args={[comprimentoBau - 0.4, 0.06, 0.05]} />
              <meshStandardMaterial color="#b6bec7" metalness={0.75} roughness={0.3} />
            </mesh>
          ))}
          {Array.from({ length: 14 }, (_, i) => (
            <mesh key={i} raycast={semRaycast} castShadow position={[-(comprimentoBau - 0.5) / 2 + i * ((comprimentoBau - 0.5) / 13), 0.16, 0]} rotation={[Math.PI / 2, 0, 0]}>
              <cylinderGeometry args={[0.018, 0.018, 0.52, 6]} />
              <meshStandardMaterial color="#b6bec7" metalness={0.75} roughness={0.3} />
            </mesh>
          ))}
          {[-1.2, 1.2].map((x) => (
            <mesh key={x} raycast={semRaycast} position={[x, 0.06, 0]}>
              <boxGeometry args={[0.08, 0.12, 0.6]} />
              <meshStandardMaterial color={PRETO} />
            </mesh>
          ))}
        </group>
        <group position={[xBauFrente + 0.55, Y_TETO_BAU, 0.55]}>
          <mesh raycast={semRaycast} castShadow position={[0, 0.12, 0]}>
            <cylinderGeometry args={[0.18, 0.22, 0.24, 14]} />
            <meshStandardMaterial color={VERMELHO} roughness={0.35} />
          </mesh>
          <mesh raycast={semRaycast} castShadow position={[-0.16, 0.34, 0]} rotation={[0, 0, Math.PI / 3]}>
            <cylinderGeometry args={[0.05, 0.075, 0.5, 12]} />
            <meshStandardMaterial color={CROMO} metalness={0.85} roughness={0.2} />
          </mesh>
        </group>
        <group position={[X_TRASEIRA - 0.75, Y_TETO_BAU + 0.3, 0.55]} rotation={[Math.PI / 2, 0, 0]}>
          <mesh raycast={semRaycast} castShadow>
            <cylinderGeometry args={[0.3, 0.3, 0.42, 20]} />
            <meshStandardMaterial color="#c2410c" roughness={0.7} />
          </mesh>
          {[-0.22, 0.22].map((y) => (
            <mesh key={y} raycast={semRaycast} position={[0, y, 0]}>
              <cylinderGeometry args={[0.36, 0.36, 0.03, 20]} />
              <meshStandardMaterial color={VERMELHO} roughness={0.4} />
            </mesh>
          ))}
        </group>

        {/* traseira: porta de enrolar do compartimento da bomba */}
        <mesh raycast={semRaycast} position={[X_TRASEIRA + 0.006, 2.3, 0]}>
          <boxGeometry args={[0.012, 1.25, MEIA_LARGURA * 2 - 0.5]} />
          <meshStandardMaterial color={ALUMINIO} map={persiana ?? undefined} metalness={0.55} roughness={0.38} />
        </mesh>
        <mesh raycast={semRaycast} position={[X_TRASEIRA + 0.025, 1.7, 0]}>
          <boxGeometry args={[0.03, 0.05, MEIA_LARGURA * 2 - 0.8]} />
          <meshStandardMaterial color={CROMO} metalness={0.85} roughness={0.2} />
        </mesh>
        {/* traseira: chevron, lanternas, holofotes e degrau */}
        <mesh raycast={semRaycast} position={[X_TRASEIRA + 0.006, 1.35, 0]}>
          <boxGeometry args={[0.01, 0.5, MEIA_LARGURA * 2 - 0.1]} />
          <meshStandardMaterial color="#facc15" map={chevron ?? undefined} emissive="#facc15" emissiveIntensity={0.15} roughness={0.4} />
        </mesh>
        {[-1, 1].map((lado) => (
          <group key={lado}>
            <mesh raycast={semRaycast} position={[X_TRASEIRA + 0.01, 1.85, lado * 0.95]}>
              <boxGeometry args={[0.02, 0.32, 0.18]} />
              <meshStandardMaterial color="#b91c1c" emissive="#ef4444" emissiveIntensity={0.6} />
            </mesh>
            <mesh raycast={semRaycast} position={[X_TRASEIRA + 0.01, 1.62, lado * 0.95]}>
              <boxGeometry args={[0.02, 0.1, 0.18]} />
              <meshStandardMaterial color="#f59e0b" emissive="#f59e0b" emissiveIntensity={0.4} />
            </mesh>
            <mesh raycast={semRaycast} castShadow position={[X_TRASEIRA - 0.05, Y_TETO_BAU + 0.1, lado * 1.0]}>
              <CaixaArredondada args={[0.14, 0.16, 0.26]} raio={0.03} />
              <meshStandardMaterial color="#e5e7eb" emissive="#ffffff" emissiveIntensity={0.35} />
            </mesh>
          </group>
        ))}
        <mesh raycast={semRaycast} castShadow position={[X_TRASEIRA + 0.2, 0.72, 0]}>
          <boxGeometry args={[0.38, 0.06, MEIA_LARGURA * 2 - 0.2]} />
          <meshStandardMaterial color="#9aa3ad" metalness={0.75} roughness={0.35} />
        </mesh>
      </group>

      {/* --- rodas: dianteiras esterçadas para fora da pista, traseiras duplas --- */}
      {[-1, 1].map((lado) => (
        <group key={lado}>
          <RodaViatura posicao={[-2.35, 0.5, lado * (MEIA_LARGURA - 0.17)]} lado={lado as 1 | -1} esterco={0.35} />
          <RodaViatura posicao={[2.05, 0.5, lado * (MEIA_LARGURA - 0.17)]} lado={lado as 1 | -1} dupla />
        </group>
      ))}
    </group>
  )
}
